module.exports = __webpack_public_path__ + "media/Logo_full.4355715b.svg";